import React, { useEffect } from 'react';
import { RetryContext } from '@src/contexts';
import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';
import {
  intervalSelector,
  isInitializingSelector,
  selectedKPIConfigSelector,
} from '@store/overviewDashboard/base/selectors';
import { Retry } from '@components/common';
import { PAGE_TYPE } from '@utils/constants';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import { thresholdsListInitializingSelector } from '@store/overviewDashboard/spiThresholds/selectors';
import usePageTitle from '@src/hooks/usePageTitle';
import Content from './Content';
import TopPanel from './TopPanel';
import { ConfigWrapper } from './styled';
import { useParams } from 'react-router-dom';

const ExperienceDashboard = (props) => {
  const isInitializing = useSelector(isInitializingSelector);
  const isThresholdsInitializing = useSelector(thresholdsListInitializingSelector);
  const selectedKpiConfig = useSelector(selectedKPIConfigSelector);
  const interval = useSelector(intervalSelector);

  const { id: currentShareId = 'overview' } = useParams();
  const { pageType, ovbBase } = props;
  const tabs = useSelector(tabsStoreSelector);

  usePageTitle({ text: 'Overview' });

  useEffect(() => {
    if (
      pageType === PAGE_TYPE.SHARING &&
      tabs.tabsData[currentShareId] &&
      !isEqual(ovbBase, tabs.tabsData[currentShareId].config.base)
    ) {
      tabs.tabsData[currentShareId].config.base = ovbBase;
      tabs.tabsData[currentShareId].unsaved = true;
      tabs.tabsData[currentShareId].isSaved = false;
    }
  }, [ovbBase, currentShareId]);

  if (isInitializing || !selectedKpiConfig || isThresholdsInitializing) {
    return <Retry isLoading={isInitializing || !selectedKpiConfig || isThresholdsInitializing} />;
  }

  return (
    <ConfigWrapper>
      <RetryContext.Provider value={{ interval }}>
        <TopPanel currentShareId={currentShareId} pageType={pageType} />
        <Content currentShareId={currentShareId} pageType={pageType} />
      </RetryContext.Provider>
    </ConfigWrapper>
  );
};

export default ExperienceDashboard;
